import { useState } from "react"

const ButtonT=({ctaText,onclickFn,disabled})=>{
    const [loading,setLoading]=useState(false)
return(
        <button type="submit" 
        onClick={()=>{
            setLoading(true)
            onclickFn()
        }} 
        className="twyny-cta-primary w-100 mt-24" 
        disabled={loading || disabled}
        >
            {loading ? 'Chargement...' :ctaText}
          </button>
)
}
export default ButtonT